<div class="rfq-container-content" id="content">
  <div class="rfq-container-content__menu-bar">
    <div class="rfq-container-content__menu-bar__title">
      Quote
      <div
        class="rfq-container-content__menu-bar__title__tabs-blocked"
        *ngIf="false"
      >
        - reopen to continue making requests
      </div>
    </div>
    <button
      class="rfq-container-content__menu-bar--right-button-close"
      (click)="closeWidget()"
    ></button>
  </div>
  <div class="rfq-container-content__main scrollable-content">
    <div
      class="rfq-container resize-able"
      appResizerVertical
      appResizerHorizontal
      [minWidth]="minWidth"
      [minHeight]="minHeight"
    >
      <ul
        id="nav"
        class="nav scrollable-content scrollable-content--hover"
        role="tablist"
      >
        <li class="nav-item" *ngFor="let tab of tabs; index as i">
          <button
            id="tab{{ i }}"
            class="btn btn-link nav-link tab-button"
            [ngClass]="{ active: selectedIndex === i }"
            [attr.aria-selected]="selectedIndex === i"
            type="button"
            (click)="switchTabs(i)"
          >
            {{ tab.title?.quotePair.base }}{{ tab.title?.quotePair.term }}
            {{ tab.title?.productName?.longName || '---' }}
            <span
              [@tabStatus]="tab.title?.status.statusType"
              class="tab-button__status-type"
              [ngClass]="tab.title?.status.statusType"
            >
              {{ tab.title?.status.statusType }}
            </span>

            <cds-icon
              class="tab-button__remove"
              shape="times"
              (click)="removeTab(i)"
            ></cds-icon>
          </button>
        </li>
      </ul>

      <section
        role="tabpanel"
        *ngFor="let tab of tabs; index as i"
        [hidden]="selectedIndex !== i"
        [ngClass]="{ 'visible-section': selectedIndex === i }"
        #sections
      >
        <app-provider-quote-tab
          [tabItem]="tab"
          [rfqDetails]="tab.rfqDetails"
          (closeTab)="removeTab(i)"
        ></app-provider-quote-tab>
      </section>
    </div>
  </div>
</div>
